import React, {useEffect, useState} from "react";
import {getIncidentReport} from "../../../../api/maintenance/IncidentService";
import {IncidentReportCreate} from "./IncidentReportCreate";
import {IncidentReportView} from "./IncidentReportView";

function IncidentReport({id, incident, assets, handler, statusNumericValue}) {
    const [incidentReport, setIncidentReport] = useState({});

    useEffect(() => {
        getIncidentReport(id).then((response) => {
            if (response.data?.id) {
                setIncidentReport(response.data);
            }
        });
    }, [id, incidentReport?.id]);

    return !incidentReport.id ? (
        <IncidentReportCreate
            incident={incident}
            assets={assets}
            handler={handler}
            statusNumericValue={statusNumericValue}
            incidentReport={incidentReport}
            setIncidentReport={setIncidentReport}
        />
    ) : (
        <IncidentReportView
            incident={incident}
            assets={assets}
            handler={handler}
            statusNumericValue={statusNumericValue}
            incidentReport={incidentReport}
            setIncidentReport={setIncidentReport}
        />
    );
}

export {IncidentReport};
